var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "releaseNotes",
        size: "lg",
        "content-class": "rn-mmp-modal menu-bg-blue-transparent-modal",
        "header-class": "rn-modal-header",
        "footer-class": "rn-modal-footer",
        "body-class": "rn-modal-body",
        "no-close-on-backdrop": "",
        scrollable: "",
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "space-between",
                    width: "100%",
                  },
                },
                [
                  _c(
                    "h5",
                    {
                      staticClass: "mb-0",
                      staticStyle: {
                        "font-weight": "600",
                        color: "white",
                        "font-size": "0.95rem",
                        "letter-spacing": "0.02em",
                      },
                    },
                    [_vm._v("Release Notes")]
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "b-row",
                { staticClass: "w-100 justify-content-end m-0" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "rn-got-it-btn px-4",
                      on: { click: _vm.UpdateUserAcknw },
                    },
                    [_vm._v("Got it!")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c("b-row", { staticClass: "py-1 my-1" }, [
            _c(
              "label",
              { staticClass: "rn-version-label px-3 mx-3 text-center" },
              [
                _vm._v(
                  "\n        Version " +
                    _vm._s(this.versionReleaseInfo.version) +
                    "  | \n        " +
                    _vm._s(this.versionReleaseInfo.release_date) +
                    "\n      "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("b-row", { staticClass: "px-1 m-1" }, [
            _c(
              "p",
              {
                staticClass: "rn-notes-text",
                staticStyle: { "white-space": "pre-line" },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(this.versionReleaseNotes.toString()) +
                    "\n      "
                ),
              ]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }